import { render, staticRenderFns } from "./staBarCharts.vue?vue&type=template&id=466c3986"
import script from "./staBarCharts.vue?vue&type=script&lang=js"
export * from "./staBarCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports